/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ErrorLevel from './error-level';

/**
 * Typ pro chybu s úrovní důležitosti chyby.
 * @template {Error} [E = Error]
 * @typedef {E & { level: ErrorLevel }} ErrorWithLevel
 */

// TODO: Případné jiné existující funkce pro "výrobu" nebo detekci warningu
// (např. detekce levelu v Sentry nebo Loggeru) dát na jedno místo.
// - ErrorLevelUtil.fromValue
/**
 * Warning neboli chyba s úrovní důležitosti chyby s hodnotou {@link ErrorLevel.Warning}.
 * @template {Error} [E = Error]
 * @typedef {E & { level: typeof ErrorLevel.Warning }} Warning
 */

/**
 * Obohatí chybu o úroveň důležitosti chyby.
 * @template {Error} [E = Error]
 * @param {E} error
 * @param {ErrorLevel} errorLevel
 * @returns {ErrorWithLevel<E>}
 */
export function errorWithLevel(error, errorLevel) {
  const e = /** @type {ErrorWithLevel<E>} */ (error);
  e.level = errorLevel;
  return e;
}

// TODO: Přejmenovat na warningFromError nebo errorToWarning?
/**
 * Vytvoří z chyby tzv. warning, tj. obohatí chybu o úroveň důležitosti chyby
 * s hodnotou {@link ErrorLevel.Warning}.
 * @template {Error} E
 * @param {E} error
 * @returns {Warning<E>}
 */
export function errorWithLevelWarning(error) {
  return /** @type {Warning<E>} */ (errorWithLevel(error, ErrorLevel.Warning));
}
